<!-- 
Getting started hint.

When a listing has no data, we use these to display "getting started" instructions instead of
just showing an empty listing.
-->
<template>
  <div class="pt-0 pb-0 mt-5 mb-5">
    <v-layout class="justify-center">
      <v-card  
        fluid grid-list-sm
        class="home"
        style="max-width: 700px; width: 90%;"
        flat
      >
        <v-card-text>
          <v-layout row wrap class="mt-3 mb-3 px-5 pt-2 pb-0 justify-center">
            <v-flex xs1 class="hidden-xs-only text-xs-right">
              <v-icon x-large class="pr-5 mr-5" color="primary">info</v-icon>
            </v-flex>
            <v-flex xs11 class="pt-2">
              <slot/>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <slot name="button" />
          <v-btn v-if="levyCollectionId" :to="workflow" flat color="primary">
            Go to workflow
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    levyCollectionId: {
      validator: prop => typeof prop === "number" || typeof prop === "string" || prop === null,
      default: null
    }
  },
  computed: {
    workflow() {
      return `/levy-collections/${this.levyCollectionId}/workflow`;
    }
  }
};
</script>
